/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { Typography, Grid, Button } from '@mui/material';
import { CustomAvatar } from '../Avatar/CustomAvatar';
import { useState } from 'react';
import { ViewEmployeeModal } from '../Modal/ViewEmployeeModal';

const style = {
  bgcolor: 'rgba(144, 202, 249, 0.1)',
  boxShadow: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;',
  borderRadius: '5px',
  pt: 2,
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
};

const btnStyle = {
  bgcolor: 'rgba(144, 202, 249, 0.15)',
  color: '#FFF',
  borderRadius: '0 0 5px 5px',
  boxShadow: 'none !important',
};

export const EmployeeCard = (props) => {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <Grid item xs={6} sm={6} md={2}>
      <Grid container direction="column" sx={style}>
        <Grid item>
          <CustomAvatar isActive={props.isActive} src={props.src} />
        </Grid>
        <Grid item sx={{ my: 2, textAlign: 'center' }}>
          <Typography
            sx={{ lineHeight: '1', fontWeight: 500 }}
            margin={0}
            variant="subtitle1"
          >
            {props.name}
          </Typography>
          <Typography variant="caption">{props.deptname}</Typography>
          <Grid
            sx={{
              bgcolor:
                props.time.split(':')[0] === 'Last Login'
                  ? 'rgba(255,255,255,0.2)'
                  : props.time.split(':')[0] === 'Check In'
                    ? '#84D8C5'
                    : '#d5615d',
              borderRadius: '5px',
              p: 1,
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              mt: 1,
              width: '100%',
            }}
          >
            <Typography
              sx={{ lineHeight: '1', fontWeight: 500 }}
              variant="caption"
            >
              {props.time}
            </Typography>
          </Grid>
        </Grid>
        {props.view ? (
          <Button fullWidth sx={btnStyle} onClick={() => setModalOpen(true)}>
            View
          </Button>
        ) : (
          <></>
        )}
      </Grid>

      {modalOpen && (
        <ViewEmployeeModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          employeeId={props.id}
        />
      )}
    </Grid>
  );
};
